import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "grid lg:grid-cols-12 md:grid-cols-6 grid-cols-1 gap-2 w-full items-center py-2 my-0" }
const _hoisted_2 = { class: "lg:col-span-2 md:col-span-2 col-span-12 flex flex-row md:flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "ID:", -1)
const _hoisted_4 = { class: "md:text-left" }
const _hoisted_5 = { class: "lg:col-span-3 md:col-span-4 col-span-12 flex flex-row md:flex-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Nome da Política:", -1)
const _hoisted_7 = { class: "md:text-left truncate" }
const _hoisted_8 = { class: "lg:col-span-2 md:col-span-3 col-span-12 flex flex-row md:flex-row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Empresa:", -1)
const _hoisted_10 = { class: "md:text-left" }
const _hoisted_11 = { class: "lg:col-span-2 md:col-span-3 col-span-12 flex flex-row md:flex-row items-center md:items-start" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font-bold md:hidden mr-2" }, "Criado por:", -1)
const _hoisted_13 = { class: "flex justify-center md:justify-start" }
const _hoisted_14 = { class: "col-span-12 md:col-span-6 lg:col-span-3 flex flex-row lg:justify-between justify-center items-center lg:gap-4 gap-2 mt-4 md:mt-0" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { class: "w-12" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }

import { computed, ref } from 'vue'
import DsSwitch from '@/components/designSystem/Switch/index.vue'
import { useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'

import PATHS from '@/router/paths'
import { useDsPolicyStore } from '@/pinia-store/useDsPolicyStore'

import { DsPolicyItem } from '@/Network/Types/Responses/DsPolicyResponses'

import EditIcon from '@/assets/icons/edit.vue'
import DuplicateIcon from '@/assets/icons/duplicate.vue'

import UserDisplay from '../AvatarUser/index.vue'
import ConfirmDeleteModal from '@/components/designSystem/modals/confirm.delete.action.vue'
import DuplicateDsPolicyModal from '@/modules/company/Policy/DsPolicy/components/DuplicateDsPolicyModal/Index.vue'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'TableDsPolicies',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;



// const { flags } = useFeatureFlags()
const permissionsStore = usePermissionsStore()

const isLoadingDelete = ref(false)
const showDeleteModal = ref(false)
const groupToDelete = ref<{ name: string; id: number }>({ id: 0, name: '' })
const showDuplicateModal = ref(false)
const selectedPolicyToDuplicate = ref<DsPolicyItem | null>(null)

const policyStore = useDsPolicyStore()
const router = useRouter()
const toast = useToast()
const { notifyError } = useErrorToast()

const canEditPolicy = computed(() => {
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.StationCreating,
    resourceType: AuthorizationResourcesAndSubjects.Schedule
  })
})

const canTogglePolicy = computed(() => {
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.StationCreating,
    resourceType: AuthorizationResourcesAndSubjects.Schedule
  })
})

const policyDataActive = computed(() => {
  const filteredPolicies = policyStore.policies.filter((policy) => policy.id === props.data.id)
  return filteredPolicies[0].isActive
})

const handleEdit = async () => {
  try {
    await policyStore.fetchDsPolicyById(props.data.id)
  } catch (e) {
    console.error('Erro ao buscar política para edição:', e)
    notifyError(e, 'Não foi possível abrir a política de restrição para edição.')
    return
  }
  router.push(`${PATHS.MANAGE_DOCTOR_AUTHORIZATION_POLICIES}/${props.data.id}`)
}

const handleDuplicate = () => {
  selectedPolicyToDuplicate.value = props.data
  showDuplicateModal.value = true
}

const onToggle = async (value: boolean) => {
  if (value) {
    try {
      await policyStore.enableDsPolicy(props.data.id)
      toast.success(`Política ${props.data.name} ativada com sucesso!`)
    } catch (e) {
      notifyError(e, 'Não foi possível ativar a política de restrição.')
    }
  } else {
    try {
      await policyStore.disableDsPolicy(props.data.id)
      toast.success(`Política ${props.data.name} desativada com sucesso!`)
    } catch (e) {
      notifyError(e, 'Não foi possível desativar a política de restrição.')
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      !_ctx.data.isActive ? 'bg-gray-100 opacity-60' : 'bg-white',
      'border-b border-gray-200 last:border-b-0'
    ])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("p", _hoisted_4, "#" + _toDisplayString(_ctx.data.id), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.data.name), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.data.company.name), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createVNode(UserDisplay, {
              name: _ctx.data.createdBy
            }, null, 8, ["name"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_v_tooltip, { location: "top" }, {
            activator: _withCtx(({ props }) => [
              _createElementVNode("div", _mergeProps(props, { class: "ml-4" }), [
                _createVNode(EditIcon, {
                  class: _normalizeClass([[
                  !_ctx.data.isActive || !canEditPolicy.value
                    ? 'opacity-40 pointer-events-none'
                    : 'cursor-pointer'
                ], "w-8 h-8"]),
                  color: "#2f7f91",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (canEditPolicy.value ? handleEdit() : null))
                }, null, 8, ["class"])
              ], 16)
            ]),
            default: _withCtx(() => [
              (!canEditPolicy.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Você não tem permissão para editar"))
                : (!_ctx.data.isActive)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Ative a política para editar"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_17, "Editar política"))
            ]),
            _: 1
          }),
          _createVNode(_component_v_tooltip, { location: "top" }, {
            activator: _withCtx(({ props }) => [
              _createElementVNode("div", _mergeProps(props, { class: "ml-4" }), [
                _createVNode(DuplicateIcon, {
                  class: _normalizeClass([[
                  !_ctx.data.isActive || !canEditPolicy.value
                    ? 'opacity-40 pointer-events-none'
                    : 'cursor-pointer'
                ], "w-8 h-8"]),
                  color: "#2f7f91",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (canEditPolicy.value ? handleDuplicate() : null))
                }, null, 8, ["class"])
              ], 16)
            ]),
            default: _withCtx(() => [
              (!canEditPolicy.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Você não tem permissão para duplicar"))
                : (!_ctx.data.isActive)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Ative a política para duplicar"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_20, "Duplicar política"))
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_v_tooltip, { location: "top" }, {
              activator: _withCtx(({ props }) => [
                _createElementVNode("div", _mergeProps(props, {
                  class: [!canTogglePolicy.value ? 'cursor-not-allowed' : 'cursor-pointer']
                }), [
                  _createVNode(DsSwitch, {
                    disabled: !canTogglePolicy.value,
                    "model-value": policyDataActive.value,
                    "onUpdate:modelValue": onToggle
                  }, null, 8, ["disabled", "model-value"])
                ], 16)
              ]),
              default: _withCtx(() => [
                (!canTogglePolicy.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Você não tem permissão para alterar"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(policyDataActive.value ? 'Desativar política' : 'Ativar política'), 1))
              ]),
              _: 1
            })
          ])
        ])
      ])
    ], 2),
    _createVNode(DuplicateDsPolicyModal, {
      modalActive: showDuplicateModal.value,
      policy: selectedPolicyToDuplicate.value,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (showDuplicateModal.value = false))
    }, null, 8, ["modalActive", "policy"]),
    _createVNode(ConfirmDeleteModal, {
      onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (showDeleteModal.value = false)),
      show: showDeleteModal.value,
      isLoading: isLoadingDelete.value,
      title: `Atenção, confirme a desativação`,
      "text-button": `Desativar`,
      description: `Você tem certeza que deseja desativar a política:  ${groupToDelete.value.name}?`
    }, null, 8, ["show", "isLoading", "description"])
  ], 64))
}
}

})